import React from 'react';

/**
 * LoadingSpinner component
 * A reusable spinner for loading states throughout the application
 * 
 * @param {Object} props Component props
 * @param {string} props.size - Size of the spinner ('sm', 'md', 'lg')
 * @param {string} props.color - Color of the spinner ('primary', 'secondary', 'white')
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} The loading spinner component
 */
const LoadingSpinner = ({ size = 'md', color = 'primary', className = '' }) => {
  // Determine size class
  const sizeClass = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  }[size] || 'w-8 h-8';

  // Determine color class
  const colorClass = {
    primary: 'border-blue-500 border-t-transparent',
    secondary: 'border-gray-500 border-t-transparent',
    white: 'border-white border-t-transparent',
  }[color] || 'border-blue-500 border-t-transparent';

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClass} border-4 ${colorClass} rounded-full animate-spin`}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingSpinner; 